<template>
  <div>
    <el-upload :action="uploadUrl" :data="{ sourceType: sourceType ,timestamp:tiem,_sign:sign}" :headers="uploadheaders" list-type="picture-card" accept=".jpg, .jpeg, .png" :limit="imgLimit" :file-list="productImgList" :multiple="isMultiple" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-exceed="handleExceed" :on-remove="handleRemove" :on-error="imgUploadError" :on-progress="imgprogress">
      <i slot="default" class="el-icon-plus"></i>
      <!-- <div slot="productImgList" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="productImgList.url" />
        <span class="el-upload-list__item-actions">
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>  -->
      <!-- </div> -->
    </el-upload>
  </div>
</template>

<script>
import baseUrl from '@/request/base.js'
import store from '@/store'
import { baseconfig, rsaBasicModuleConfig } from '@/config.js'
import { rsa } from '@/tools/encrypt.js'
import { publicFun } from '@/tools/time.js'
import { compress } from '../../assets/js/compress.js'
import * as imageConversion from 'image-conversion'
export default {
  name: 'uploadimg',
  props: ['productImgList', 'imgLimit', 'sourceType'],
  data() {
    return {
      uploadUrl: '',
      uploadheaders: {},
      isMultiple: true,
      list: [],
      tiem: '',
      sign: '',
    }
  },
  //  watch:{
  //       'indexID':function(){
  //           console.log(22,this.indexID)
  //           this.editstep='1'
  //           this.resetForm()
  //           this.onpolicydeclarationinfomodelv2(this.valueID,this.markID)
  //       }
  // },

  created: async function () {
    if (this.imgLimit && this.imgLimit == 1) {
      this.isMultiple = false
    }
    // console.log(4444444)
    let plat_form = 3
    this.sign = rsa.signString(
      baseconfig.v + String(plat_form) + '~AUF',
      rsaBasicModuleConfig.clientPrivateKey
    )
    //时间戳
    this.tiem = rsa.encryptString(
      String(publicFun.gettimestamp()),
      rsaBasicModuleConfig.serverPublicKey
    )
    // console.log('created上传this.tiem', publicFun.gettimestamp())
    this.uploadUrl = baseUrl.basic + 'uploadfile'
    this.uploadheaders = {
      v: baseconfig.v,
      platform: 3,
    }
  },
  methods: {
    checkAllSuccess() {
      return Object.keys(this.uploadImgObj).every(
        (item) => this.uploadImgObj[item].hasSuccess
      )
    },
    handleRemove(file, fileList) {
      const uid = file.uid
      let removerIndex = this.productImgList.findIndex(
        (item) => item.uid === uid
      )
      if (removerIndex != -1) {
        this.productImgList.splice(removerIndex, 1)
      }
      this.$emit('DelImgSuccess', this.productImgList)
    },
    imgprogress() {
      // this.tiem=rsa.encryptString(String(publicFun.gettimestamp()),rsaBasicModuleConfig.serverPublicKey);
      console.log('imgprogress', this.tiem, publicFun.gettimestamp())
    },
    beforeAvatarUpload(file) {
      this.tiem = rsa.encryptString(
        String(publicFun.gettimestamp()),
        rsaBasicModuleConfig.serverPublicKey
      )
      //文件上传之前调用做一些拦截限制
      let beforeUploadObj = {
        uid: file.uid,
        url: '',
      }
      const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension =
        testmsg === 'jpg' || testmsg === 'jpeg' || testmsg === 'png'
      if (!extension) {
        if (!extension) {
          this.$message({
            message: '只能上传JPG、JPEG、PNG格式的图片!',
            type: 'error',
          })
        }
      } else {
        return new Promise((resolve, reject) => {
          //项目要求是大于5MB的图片进行压缩，可根据项目情况自行判断
          if (file.size > 1 * 1024 * 1024) {
            const loading = this.$loading({
              lock: true,
              text: '压缩中......',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.8)',
            })
            imageConversion.compressAccurately(file, 1024).then((res) => {
              loading.close()
              resolve(res)
            })
          } else {
            resolve(file)
          }
        })
      }
      return extension
      // const imageConversion = require("image-conversion");
      // console.log('压缩前'+(file.size / 1024)+"K");
      // this.loading = true;
      // await imageConversion.compressAccurately(file, 100).then(res => {
      //     this.loading = false;
      //     console.log('压缩后'+(res.size / 1024)+"K");
      //     return compress(res)
      //     // console.log('压缩后'+(res.size / 1024)+"K");
      //     // console.log(res);
      // })
      // if (file.size / 1024 / 1024 > 1) {
      //     const loading = this.$loading({
      //       lock: true,
      //       text: '压缩中......',
      //       spinner: 'el-icon-loading',
      //       background: 'rgba(0, 0, 0, 0.8)',
      //     })
      //     var compressFile = compress(file)
      //     loading.close()
      //     return compressFile

      // } else {
      //   return compress(file)
      // }
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code == 100) {
        //         //图片上传成功
        const uid = file.uid
        let lef = 0
        let imgArr = []
        console.log(fileList[0].response)
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].status != 'success') {
            lef += 1
          } else {
            if (lef == 0 && fileList[i].response) {
              console.log('图片数组', this.productImgList)
              console.log()
              let imgobj = {
                //fileList[i].response.result[0].imgUrl
                url: fileList[i].response.result[0].imgUrl,
                status: 'success',
                uid: uid,
              }
              imgArr.push(imgobj)
              // this.productImgList.push(imgobj)
            }
          }
        }
        console.log(lef)
        if (lef == 0) {
          console.log(imgArr, this.productImgList)
          this.$emit('UploadImgSuccess', imgArr)
        }
      } else {
        var array = [...this.productImgList]
        this.productImgList = array
        this.$message.error('上传图片失败!')
      }
    },
    handleExceed(files, productImgList) {
      //图片上传超过数量限制
      console.log('iiii', files.length)
      this.$message.error('上传图片不能超过' + this.imgLimit + '张!')
    },
    imgUploadError(err, file, productImgList) {
      //图片上传失败调用
      this.$message.error('上传图片失败!')
    },
    getNum(start, end) {
      return Math.floor(Math.random() * (end - start) + start)
    },
    httprequest() {
      console.log('4441411')
    },
  },
}
</script>
